import { render, staticRenderFns } from "./myOrderDetails.vue?vue&type=template&id=2a4aa438&scoped=true&"
import script from "./myOrderDetails.vue?vue&type=script&lang=js&"
export * from "./myOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./myOrderDetails.vue?vue&type=style&index=0&id=2a4aa438&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4aa438",
  null
  
)

export default component.exports